module.exports = __webpack_public_path__ + "409b22f334541b6c0850790375bcde3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/nuveen.png
// module id = 1700
// module chunks = 0